import { eventListener } from './event';

export function clickOutside(target, fn, options = {}) {
  const {
    capture = true,
    ignore = [],
  } = options;

  const event = eventListener(document, 'click', listener, {
    capture,
    passive: true,
  });

  function listener(event) {
    if (
      !target
      || event.target === target
      || event.composedPath().includes(target)
    ) {
      return;
    }

    if (shouldIgnore(event)) {
      return;
    }

    fn(event);
  }

  function shouldIgnore(event) {
    return ignore.some(target => {
      if (typeof target === 'string') {
        return [...document.querySelectorAll(target)]
          .some(el => el === event.target || event.composedPath().includes(el));
      }

      return target && (event.target === target || event.composedPath().includes(target));
    });
  }

  return event;
}
